module.exports = __webpack_public_path__ + "static/media/House.6c415c2a.svg";